import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: ${props => props.theme.backgroundDark};
  width: 306px;
  padding: 12px 12px 0;
  border: ${props => props.theme.border.standard} solid
    ${props => props.theme.border.color};
  border-radius: ${props => props.theme.br.md};
  box-shadow: ${props => props.theme.boxShadowBottom};

  .checkout-button {
    align-self: flex-end;
    width: 110px;
    margin: 20px 8px;
    margin-top: 8px;
  }

  .empty-cart {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 140px;

    p {
      font-size: 16px;
    }
  }
`;

export const ItemList = styled.div`
  max-height: 260px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: ${props => props.theme.backgroundHover} transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${props => props.theme.backgroundHover};
    border-radius: ${props => props.theme.br.pill};
  }
`;

export const CartItem = styled.div`
  display: grid;
  grid-template-columns: 4.5fr 1fr;
  align-content: center;
  align-items: center;
  margin-bottom: 2px;
  padding: 6px 10px;
  border-radius: ${props => props.theme.br.md};
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${props => props.theme.backgroundHover};
  }

  .track-button {
    background-color: transparent;
    border: none;
    padding: 0;
    width: 100%;
    text-align: left;
    cursor: pointer;
  }

  .album-art {
    width: 38px;
    height: 38px;
  }

  .remove-icon {
    margin-left: 12px;
    cursor: pointer;
  }

  .track-container {
    display: flex;
    align-items: center;
  }

  .track-detail {
    display: flex;
    align-items: center;
    margin-left: 0.75rem;
  }
`;
